<template>
    <div
        class="user-list-area"
        :style="{ width: listWidth + '%' }">
        <div class="user-list-title">
            <div
                v-for="(title, titleIndex) in titles"
                :key="titleIndex"
                :style="{ width: columnWidths[titleIndex] + '%'}">
                {{ title }}
            </div>
        </div>

        <div
            @scroll="scrolledToBottom"
            class="user-list">
            <div
                v-for="(item, index) in data"
                :key="index"
                v-on:click="clickItem(item)"
                :class="['user-line', index % 2 == 0 ? '' : 'user-line-even']"
                :style="clickCallback ? 'cursor: pointer;' : ''"
            >
                <div
                    v-for="(render, renderIndex) in cellRenders(item, index)"
                    :key="renderIndex"
                    :style="render.style">
                    {{ render.value }}
                </div>
            </div>
            <div class="bottom-button-padding">
                <div
                    class="reach-bottom-message"
                    v-if="reachBottom">
                    所有数据都加载完毕啦 O(∩_∩)O~~
                </div>
            </div>
        </div>

        <img
            v-if="addCallback"
            v-on:click="addItem"
            class="add-icon"
            src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/user_add.svg"/>
    </div>
</template>

<script>
 export default {
     name: 'NoScrollListView',
     data() {
         return {
             data: [],
             dataOffset: 0,
             scrollToBottom: false,
             reachBottom: false
         }
     },
     props: {
         titles: Array,
         columnWidths: Array,
         columnCells: Array,
         fetchCallback: Function,
         clickCallback: Function,
         addCallback: Function,
         listWidth: Number,
         bottomToFetch: {
             default: true,
             type: Boolean
         }
     },
     components: {
     },
     computed: {
     },
     mounted() {
         if (this.fetchCallback) {
             this.fetchCallback(this.dataOffset, this.updateList)
         }
     },
     methods: {
         cellRenders(item, index) {
             var renders = []

             for (var i = 0; i < this.columnCells.length; i++) {
                 renders.push({
                     value: this.resolve(this.columnCells[i].value, item, index),
                     style: this.columnCells[i].style + " width: " + this.columnWidths[i] + "%;"
                 })
             }

             return renders
         },
         resolve(path, obj, index) {
             if (path == "") {
                 return index + 1
             } else {
                 return path.split('.').reduce(function(prev, curr) {
                     return prev ? prev[curr] : null
                 }, obj || self)
             }
         },
         initList(data) {
             this.data = data
         },
         research() {
             this.data = []
             this.dataOffset = 0
             this.scrollToBottom = false
             this.reachBottom = false

             if (this.fetchCallback) {
                 this.fetchCallback(this.dataOffset, this.updateList)
             }
         },
         updateList(newData) {
             if (this.scrollToBottom && newData.length == 0) {
                 this.reachBottom = true
             }

             if (newData.length > 0) {
                 this.data = this.data.concat(newData)
                 this.dataOffset += newData.length
             }

             this.scrollToBottom = false
         },
         scrolledToBottom(event){
             if (this.bottomToFetch) {
                 var el = event.srcElement

                 /* Need increment 1 of height, avoid Chrome failed in Windows system. */
                 if (el.scrollTop >= (el.scrollHeight - el.clientHeight - 1)) {
                     this.scrollToBottom = true

                     if (this.fetchCallback) {
                         this.fetchCallback(this.dataOffset, this.updateList)
                     }
                 }
             }
         },
         clickItem(item) {
             if (this.clickCallback) {
                 this.clickCallback(item)
             }
         },
         addItem() {
             if (this.addCallback) {
                 this.addCallback()
             }
         }
     },
 }
</script>

<style scoped>
 .user-list-area {
     background-color: #FFF;
     border-radius: 5px;

     position: relative;
 }

 .user-list-title {
     width: 100%;
     height: 60px;
     background-color: #FAFBFB;
     border-radius: 5px 5px 0px 0px;

     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: space-around;

     border-bottom: 1px solid #EFEFEF;

     font-size: 14px;
     font-weight: bold;
     color: #666;

     padding-left: 10px;
     padding-right: 10px;
 }

 .user-list {
     overflow-y: auto;
     width: 100%;
     height: calc(100% - 60px);
     border-radius: 0px 0px 5px 5px;
 }

 .user-line {
     display: flex;
     flex-direction: row;
     align-items: center;
     height: 50px;
 }

 .user-line:hover {
     color: #FFF;
     background-color: #5CC9F5;
 }

 .user-line-even {
     background-color: #FAFBFB;
 }

 .add-icon {
     position: absolute;
     width: 120px;
     height: 120px;
     right: 0;
     bottom: 0;
     cursor: pointer;
 }

 .bottom-button-padding {
     height: 150px;
 }

 .reach-bottom-message {
     margin-top: 20px;
     color: #AAA;
 }
</style>
